/* Progressive enhancement around Ella ColorSwatch; no replacement variant picker. */
(() => {
  if (window.fvCollectionV14) return;
  window.fvCollectionV14 = true;
  const guideInit = () => document.querySelectorAll('.fv-collection-v14-story .fv-collection-guide:not([data-fv-ready])').forEach(d => {
    d.dataset.fvReady = 'true'; d.open = false;
  });
  const mobile = matchMedia('(max-width:749px)'), narrow = matchMedia('(max-width:359px)');
  const swatchLayout = card => {
    const list = card.querySelector('color-swatch .swatch-list');
    if (!list) return;
    const band = mobile.matches ? (narrow.matches ? '2' : '3') : 'desktop';
    if (list.dataset.fvSwatchBand === band) return;
    list.dataset.fvSwatchBand = band;
    const direct = [...list.children].filter(item => item.classList.contains('swatch-item'));
    const limit = band === 'desktop' ? direct.length : Number(band);
    direct.forEach((item, index) => item.classList.toggle('fv-swatch-overflow', index >= limit));
    const hiddenCount = list.querySelectorAll('.swatch-item').length - Math.min(limit, direct.length);
    let group = list.querySelector('.group-swatch'), more = list.querySelector('.item-swatch-more');
    if (hiddenCount && !group) {
      group = document.createElement('li'); group.className = 'group-swatch'; group.style.display = 'none';
      list.append(group);
    }
    if (hiddenCount && !more) {
      more = document.createElement('li'); more.className = 'item-swatch-more item';
      const button = document.createElement('button'); button.type = 'button';
      button.className = 'number-showmore t-button cursor-pointer'; button.title = 'More Color';
      const sign = document.createElement('span'), count = document.createElement('span');
      sign.textContent = '+'; count.className = 'text-number'; button.append(sign, count); more.append(button); list.append(more);
    }
    if (!more) return;
    more.hidden = hiddenCount === 0;
    if (!hiddenCount && group?.style.display !== 'none') group.style.display = 'none';
    const button = more.querySelector('button');
    button.querySelector('.text-number').textContent = String(hiddenCount);
    button.querySelector('span').textContent = group?.style.display === 'flex' ? '-' : '+';
    button.setAttribute('aria-expanded', String(group?.style.display === 'flex'));
    button.setAttribute('aria-label', `More colors (${hiddenCount})`);
    // Reuse Ella's own more-colour handler, keeping all original swatch nodes/listeners.
    if (typeof window.initMoreSwatchButtons === 'function') window.initMoreSwatchButtons(card);
  };
  const init = () => {
    guideInit();
    document.querySelectorAll('.fv-collection-v14 .card-wrapper').forEach(card => {
      swatchLayout(card);
      const title = card.querySelector('.card__heading>a');
      if (title && !title.title) title.title = title.textContent.trim();
      const badge = card.querySelector('.jdgm-prev-badge'), fallback = card.querySelector('[data-fv-review-fallback]');
      const badgeReady = !!badge && getComputedStyle(badge).display !== 'none' && getComputedStyle(badge).visibility !== 'hidden';
      card.classList.toggle('fv-review-ready', badgeReady);
      if (fallback) fallback.hidden = badgeReady;
      card.querySelectorAll('color-swatch .swatch[data-variant-id]').forEach(swatch => {
        if (swatch.dataset.fvReady) return;
        swatch.dataset.fvReady = 'true';
        swatch.tabIndex = 0; swatch.setAttribute('role', 'button');
        swatch.setAttribute('aria-label', swatch.parentElement.querySelector('.tooltip')?.textContent?.trim() || swatch.dataset.title);
        swatch.setAttribute('aria-pressed', String(swatch.closest('.swatch-item').classList.contains('active')));
        swatch.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); swatch.click(); }
        });
      });
      const media = card.querySelector('card-media'), secondary = media?.querySelector('.media>img:nth-child(2)');
      if (!secondary || media.dataset.fvReady) return;
      media.dataset.fvReady = 'true';
      // The image link is untouched: first touch still navigates to the PDP.
      const controls = document.createElement('div'); controls.className = 'fv-secondary-controls';
      const primaryButton = document.createElement('button'), secondaryButton = document.createElement('button');
      [primaryButton, secondaryButton].forEach(button => { button.type = 'button'; button.className = 'fv-secondary-dot'; });
      primaryButton.setAttribute('aria-label', media.dataset.fvPrimaryLabel);
      secondaryButton.setAttribute('aria-label', media.dataset.fvAlternateLabel);
      primaryButton.setAttribute('aria-pressed', 'true'); secondaryButton.setAttribute('aria-pressed', 'false');
      controls.append(primaryButton, secondaryButton); media.append(controls);
      const reset = () => { media.classList.remove('fv-secondary-active'); primaryButton.setAttribute('aria-pressed', 'true'); secondaryButton.setAttribute('aria-pressed', 'false'); };
      const fail = () => { reset(); media.classList.add('fv-secondary-error'); controls.hidden = true; };
      secondary.addEventListener('error', fail);
      if (secondary.complete && !secondary.naturalWidth) fail();
      primaryButton.addEventListener('click', reset);
      const showSecondary = () => {
        if (secondary.complete && !secondary.naturalWidth) { fail(); return; }
        media.classList.add('fv-secondary-active'); primaryButton.setAttribute('aria-pressed', 'false'); secondaryButton.setAttribute('aria-pressed', 'true');
      };
      secondaryButton.addEventListener('click', showSecondary);
      let gesture = null, suppressClickUntil = 0;
      const clearDrag = () => { media.classList.remove('fv-gallery-dragging'); media.style.removeProperty('--fv-gallery-drag'); };
      media.addEventListener('pointerdown', event => {
        if (!mobile.matches || controls.hidden || event.isPrimary === false || event.button !== 0 || event.target.closest('button')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, width: media.clientWidth, dx: 0, dragging: false };
      });
      media.addEventListener('pointermove', event => {
        if (!gesture || event.pointerId !== gesture.id || gesture.scrolling) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (!gesture.dragging && Math.abs(dy) > 10 && Math.abs(dy) >= Math.abs(dx)) { gesture.scrolling = true; return; }
        if (!gesture.dragging && Math.abs(dx) < 10) return;
        if (!gesture.dragging) { gesture.dragging = true; media.setPointerCapture(event.pointerId); media.classList.add('fv-gallery-dragging'); }
        gesture.dx = dx;
        const active = media.classList.contains('fv-secondary-active'), atEdge = active ? dx < 0 : dx > 0;
        const distance = Math.max(-gesture.width, Math.min(gesture.width, atEdge ? dx * .15 : dx));
        media.style.setProperty('--fv-gallery-drag', `${distance}px`);
      });
      media.addEventListener('pointerup', event => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const finished = gesture; gesture = null; clearDrag();
        if (media.hasPointerCapture(event.pointerId)) media.releasePointerCapture(event.pointerId);
        if (!finished.dragging && !finished.scrolling) return;
        suppressClickUntil = performance.now() + 350;
        if (finished.scrolling) return;
        if (!mobile.matches || controls.hidden || Math.abs(finished.dx) < Math.max(36, finished.width * .12)) return;
        if (finished.dx < 0) showSecondary(); else reset();
      });
      media.addEventListener('pointercancel', () => { gesture = null; clearDrag(); });
      media.addEventListener('dragstart', event => { if (mobile.matches && !controls.hidden) event.preventDefault(); });
      media.addEventListener('click', event => {
        if (!event.target.closest('.fv-secondary-controls') && performance.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
      }, true);
      media.addEventListener('fv-native-colour-selected', () => {
        // Gallery slot 2 has no guaranteed colour association. Do not show another colour after selection.
        gesture = null; clearDrag(); reset(); media.classList.add('fv-secondary-disabled'); controls.hidden = true;
      });
    });
  };
  document.addEventListener('click', event => {
    const more = event.target.closest('.fv-collection-v14 .number-showmore');
    if (more) queueMicrotask(() => {
      const expanded = more.closest('.swatch-list').querySelector('.group-swatch')?.style.display === 'flex';
      more.setAttribute('aria-expanded', String(expanded));
      more.setAttribute('aria-label', expanded ? 'Show fewer colors' : `More colors (${more.querySelector('.text-number').textContent})`);
    });
    const swatch = event.target.closest('.fv-collection-v14 color-swatch .swatch[data-variant-id]');
    if (!swatch) return;
    const card = swatch.closest('.card-wrapper');
    // Ella's event runs first. Mirror its actual selected link and active state; do not choose variants here.
    queueMicrotask(() => {
      const chosen = card.querySelector('.card__heading>a');
      if (!chosen?.href.includes(`variant=${swatch.dataset.variantId}`)) return;
      card.querySelectorAll('a.link-wrap,[data-fv-options]').forEach(link => { link.href = chosen.href; });
      card.querySelectorAll('color-swatch .swatch[data-variant-id]').forEach(s => s.setAttribute('aria-pressed', String(s.closest('.swatch-item').classList.contains('active'))));
      const json = card.querySelector('template')?.content.querySelector('[data-json-product]')?.dataset.jsonProduct;
      if (json) {
        const variant = JSON.parse(json).variants.find(v => String(v.id) === swatch.dataset.variantId);
        const status = card.querySelector('[data-fv-availability]');
        if (status && variant) status.textContent = variant.available ? '' : status.dataset.unavailable;
      }
      card.querySelector('card-media')?.dispatchEvent(new Event('fv-native-colour-selected'));
    });
  });
  mobile.addEventListener('change', init); narrow.addEventListener('change', init);
  let scheduled = false;
  new MutationObserver(records => {
    // Dragging writes only this media's transform variable; avoid reinitializing every card per frame.
    if (records.every(record => record.type === 'attributes' && record.target.matches('card-media'))) return;
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(() => { scheduled = false; init(); });
  }).observe(document.body, {childList:true, subtree:true,attributes:true,attributeFilter:['style']});
  init();
})();
